// extracted by mini-css-extract-plugin
export default {"container":"Favorites_container__On-1f"};